import React from 'react';
import { get } from 'lodash';

import { useFormValues } from '@funnels/hooks';

import { DatePickerInputField, StringDisplay } from '../../Fields';
import { FunnelViewProps, EditableViewProps, StringReadOnlyViewProps } from '../types';
import { ThreeYearsDate } from '../../Layouts/ThreeYears/types';
import { validateEndDate, validateStartDate } from './utils';

interface EmploymentDatesFunnelProps extends FunnelViewProps {
  startDate: ThreeYearsDate;
  endDate?: ThreeYearsDate;
  validate?: (value: any) => string | undefined;
}

export const EmploymentDatesFunnelView = (props: EmploymentDatesFunnelProps) => {
  const { startDate, endDate, validate } = props;
  const [formValues] = useFormValues();
  const startDateValue = get(formValues, startDate.name);

  return (
    <>
      <DatePickerInputField {...startDate} validate={validate || validateStartDate} />
      {endDate && (
        <DatePickerInputField key={`from-${startDateValue}`} {...endDate} validate={validateEndDate(startDateValue)} />
      )}
    </>
  );
};

interface EmploymentDatesEditableProps extends EditableViewProps {
  startDate: ThreeYearsDate;
  endDate?: ThreeYearsDate;
  validate?: (value: any) => string | undefined;
}

export const EmploymentDatesEditableView = (props: EmploymentDatesEditableProps) => {
  const { startDate, endDate, validate } = props;
  const [formValues] = useFormValues();
  const startDateValue = get(formValues, startDate.name);

  return (
    <>
      <DatePickerInputField {...startDate} validate={validate || validateStartDate} />
      {endDate && (
        <DatePickerInputField key={`from-${startDateValue}`} {...endDate} validate={validateEndDate(startDateValue)} />
      )}
    </>
  );
};

export const EmploymentDatesReadOnlyView = (props: StringReadOnlyViewProps) => {
  return <StringDisplay title={props.title} value={props.value} />;
};
